export const accCheckerMenuItemText = "b$a";
export default {accCheckerMenuItemText};